import { useTranslation } from 'react-i18next';
import { BenefitDisplayContent } from './BenefitDisplayContent';
import { WhiteDescriptions as Descriptions } from './styledComponent';

interface DescriptionSectionProps {
  hasDependents?: boolean;
  reimbursementRate?: string;
  accommodationLevel?: string;
}

const DescriptionSection = ({
  // hasDependents,
  reimbursementRate,
  accommodationLevel,
}: DescriptionSectionProps): JSX.Element => {
  const { t } = useTranslation();
  const items: BenefitDisplayContent[] = [];

  // const isDependentCovered = hasDependents ? t('common.yes') : t('common.no');
  // items.push({
  //   title: t('benefits.dependentCover'),
  //   value: isDependentCovered,
  // });

  if (reimbursementRate) {
    const rounded = Math.round(parseFloat(reimbursementRate));
    items.push({
      title: t('benefits.reimbursementRate'),
      value: `${rounded}%`,
    });
  }

  if (accommodationLevel) {
    items.push({
      title: t('benefits.accommodationLevel'),
      value: accommodationLevel,
    });
  }

  return items.length > 0 ? (
    <Descriptions layout="vertical" bordered size="small">
      {items.map((description, index) => (
        <Descriptions.Item key={index} label={description.title}>
          {description.value}
        </Descriptions.Item>
      ))}
    </Descriptions>
  ) : (
    <></>
  );
};

export default DescriptionSection;
